module.exports = __webpack_public_path__ + "media/images/ofn-logo-8be6817c6ed6be78b0d42f28c3444056.png";